import { gql } from "@apollo/client";
import { CardFragment } from "../fragments/post";

export const GetContributors = gql`
  query GET_CONTRIBUTORS {
    contributors(first: 30) {
      nodes {
        id
        uri
        contributorId
        name
        contributormeta {
          bio
          facebookLink
          image {
            node {
              mediaItemUrl
              srcSet
            }
          }
          twitterLink
          instagramLink
        }
      }
    }
  }
`;

export const GetContributorBySlug = gql`
  query GET_CONTRIBUTORS($id: ID!) {
  contributor(id: $id, idType: URI) {
    description
    name
    uri
    contributormeta {
      bio
      facebookLink
      fieldGroupName
      instagramLink
      twitterLink
      image {
        node {  
          mediaItemUrl
            srcSet
          }
        }
    }
    posts(first: 5) {
      nodes {
        ${CardFragment}
      }
    }
  }
}
`;

export const GET_SINGLE_CONTRIBUTOR_POSTS_PAGINATED = gql`
  query GET_CONTRIBUTOR($id: ID!, $after: String, $first: Int) {
    contributor(id: $id, idType: URI) {
      posts(first: $first, after: $after) {
        edges {
          cursor
          node {
            ${CardFragment}
          }
        }
      }
    }
  }
`;
